@use "breakpoint.module" as *;

:root {
    --container-width: 100vw;
    --grid-column-count: 12;
    --grid-gap: 40px;
    --container-min-margin: 48px;

    // Aliases to match Fuji's terminology
    --spacer-gutter: var(--grid-gap);
    --spacer-margin: var(--container-min-margin);

    // probs don't need to edit things below here
    @media ($below-tablet) {
        --container-min-margin: 32px;
        --grid-gap: 24px;
    }

    @media ($below-mobile) {
        --grid-column-count: 6;
        --container-min-margin: 20px;
        --grid-gap: 16px;
    }

    --container-margin: max(
        calc((100vw - var(--container-width)) / 2),
        var(--container-min-margin)
    );
    --actual-margin: calc(var(--container-margin) - var(--grid-gap));

    /*
       container width = (gap X # of gaps (aka # of columns - 1)) + (column width X # of columns)
       Below solves for column width - useful for calculations, generally best to use other layout methods
       I do not know why it is closer to correct if I subtract a pixel - I assume fr rounds somewhere
    */
    --grid-column-width: calc(
        (
                100vw - 2 * var(--actual-margin) -
                    ((var(--grid-column-count) + 1) * var(--grid-gap))
            ) /
            var(--grid-column-count) - 1px
    );
}

@function span($col: 1) {
    @if $col == 1 {
        @return var(--grid-column-width);
    } @else {
        @return calc(
            (
                    $col * round(down, var(--grid-column-width), 1px) +
                        ($col - 1) * var(--grid-gap)
                ) -
                1px
        );
    }
}

.grid {
    display: grid;
    grid-template-columns:
        [margin-start] var(--actual-margin)
        [content-start] repeat(
            var(--grid-column-count),
            [col-start] minmax(0, 1fr) [col-end]
        )
        [content-end] var(--actual-margin) [margin-end];
    column-gap: var(--grid-gap);
    align-items: start;
}

.repeater {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: subgrid;
}

.inherit {
    grid-column: var(--default-columns, content-start / content-end);
}

.fullbleed {
    grid-column: margin-start / margin-end;
}

.fullwidth {
    grid-column: content;
}

.col10 {
    grid-column: col-start 2 / span 10;

    @media ($below-tablet) {
        grid-column: content;
    }
}

.col8 {
    grid-column: col-start 3 / span 8;

    @media ($below-tablet) {
        grid-column: content;
    }
}

.col6 {
    grid-column: col-start 4 / span 6;

    @media ($below-tablet) {
        grid-column: col-start 2 / col-end 11;
    }

    @media ($below-mobile) {
        grid-column: content;
    }
}

.split6x6 {
    grid-column: content-start / span 6;

    & + & {
        grid-column-start: col-start 7;
    }

    @media ($below-mobile) {
        grid-column: content;
    }
}

.split7x3 {
    grid-column: col-start 2 / span 7;

    & + & {
        grid-column: col-start 9 / span 3;
    }

    @media ($below-tablet) {
        grid-column: span 6;

        & + & {
            grid-column: span 6;
        }
    }

    @media ($below-mobile) {
        grid-column: content;

        & + & {
            grid-column: content;
        }
    }
}
